import React, { useEffect, useState } from 'react';
import { Card, Table, Space, Input, DatePicker, Button, Tag, message } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { visitorService } from '../services/visitor';

interface IPStatItem {
  ip: string;
  ip_type: 'IPv4' | 'IPv6';
  count: number;
  first_access: string;
  last_access: string;
}

const IPStats: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState<IPStatItem[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [search, setSearch] = useState('');
  const [dateRange, setDateRange] = useState<any>([dayjs().subtract(2, 'day'), dayjs()]);

  const loadData = async (p = page, s = size) => {
    setLoading(true);
    try {
      const data = await visitorService.getIPStats({
        search,
        dateRange: dateRange ? [dateRange[0]?.format('YYYY-MM-DD'), dateRange[1]?.format('YYYY-MM-DD')] : undefined,
        page: p,
        size: s,
      });
      setList(data.list || []);
      setTotal(data.total || 0);
      setPage(data.page || p);
      setSize(data.size || s);
    } catch (e: any) {
      message.error(e?.message || '加载失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadData(1, size); // 初始加载
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddBlacklist = async (ip: string) => {
    try {
      await visitorService.addIPToList({ ip, type: 'blacklist' });
      message.success('已加入黑名单');
    } catch (e: any) {
      message.error(e?.message || '操作失败');
    }
  };

  const columns: ColumnsType<IPStatItem> = [
    { title: 'IP地址', dataIndex: 'ip', key: 'ip' },
    { title: 'IP类型', dataIndex: 'ip_type', key: 'ip_type', render: (t) => <Tag>{t}</Tag> },
    { title: '访问次数', dataIndex: 'count', key: 'count' },
    { title: '首次访问时间', dataIndex: 'first_access', key: 'first_access', render: (v) => dayjs(v).format('YYYY-MM-DD HH:mm:ss') },
    { title: '最近访问时间', dataIndex: 'last_access', key: 'last_access', render: (v) => dayjs(v).format('YYYY-MM-DD HH:mm:ss') },
    // {
    //   title: '操作', key: 'action', render: (_, r) => (
    //     <Space>
    //       <Button danger onClick={() => handleAddBlacklist(r.ip)}>加入黑名单</Button>
    //     </Space>
    //   )
    // }
  ];

  return (
    <Card title="IP访问统计" extra={
      <Space>
        <Input placeholder="输入IP搜索" value={search} onChange={(e) => setSearch(e.target.value)} allowClear style={{ width: 220 }} />
        <DatePicker.RangePicker value={dateRange} onChange={(v) => setDateRange(v)} />
        <Button type="primary" onClick={() => loadData(1, size)}>搜索</Button>
      </Space>
    }>
      <Table
        rowKey={(r) => r.ip}
        loading={loading}
        columns={columns}
        dataSource={list}
        pagination={{ current: page, pageSize: size, total, onChange: (p, s) => loadData(p, s) }}
      />
    </Card>
  );
};

export default IPStats;


